import request from '@/utils/request' //引入封装好的 axios 请求

//首页合作机构图片
export function getCooperationList () {
    return request({
        url: '/api/v1/file/bankImgList',
        method: 'get',
        data: {}
    })
}

//首页合作机构图片
export function getResultData () {
    return request({
        url: '/api/v1/fStatistics/selectList',
        method: 'post',
        data: {}
    })
}

//体系介绍  pdf
export function getFilePdf () {
    return request({
        url: '/api/v1/file/fileList',
        method: 'get',
        data: {}
    })
}


//产品超市
export function pageList (data = {}) {
    return request({
        url: '/api/credit/product/pageListToNotToken ',
        method: 'post',
        data
    })
}



//产品详情

export function detail (data = {}) {
    return request({
        url: '/api/credit/product/detailToNotToken',
        method: 'post',
        data
    })
}



//产品信用详情

export function getDictionaryByCode (code) {
    return request({
        url: '/api/credit/dictionary/getDictionaryByCode?code=' + code,
        method: 'post',

    })
}


//产品超市列表


export function listToNotToken (data = {}) {
    return request({
        url: '/api/credit/product/listToNotToken',
        method: 'post',
        data
    })
}


//申请金额
export function operate (data = {}) {
    return request({
        url: '/api/credit/application/operate',
        method: 'post',
        data
    })
}


//申请金额
export function productInfoList (data = {}) {
    return request({
        url: '/api/credit/product/productInfoList',
        method: 'post',
        data
    })
}





export function queryProductInfoByTypeId (data = {}) {
    return request({
        url: '/api/credit/product/queryProductInfoByTypeId',
        method: 'post',
        data
    })
}


export function productDetail (data = {}) {
    return request({
        url: '/api/credit/product/detail',
        method: 'post',
        data
    })
}


//获取机构详情
export function queryProductHandlingInfo (data = {}) {
    return request({
        url: '/api/credit/application/queryProductHandlingInfo',
        method: 'post',
        data
    })
}


//获取机构详情
export function selectApplyCount (data = {}) {
    return request({
        url: '/api/credit/application/selectApplyCount',
        method: 'post',
        data
    })
}

